<template>
  <div>
    <LoginForm/>
    <SidebarImage />
  </div>
</template>

<script>
import LoginForm from '@/components/Auth/LoginForm'
import SidebarImage from '@/components/SideBar/SidebarImage.vue'

export default {
  name: 'LoginView',
  components: { LoginForm, SidebarImage }
}
</script>

<style scoped>
</style>
